import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getNutTypeFieldsWithConditions = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_NUT_TYPE_FIELD_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};